'use client';

import { createContext, useContext, PropsWithChildren, useEffect } from 'react';
import { useSearchParams, usePathname } from 'next/navigation';
import { LOAD_BOARD_PAGE_PATH } from '~/app/pages';
import useSessionStorage from '../../../../../../_ui/shared/storage/useSessionStorage';

const LoadBoardLastQueryStringContext = createContext('');

export function useLoadBoardLastQueryString() {
  return useContext(LoadBoardLastQueryStringContext);
}

export default function LoadBoardLastQueryStringProvider({
  children,
}: PropsWithChildren) {
  const searchParams = useSearchParams();
  const currentPath = usePathname();
  const [lastQueryString, setLastQueryString] = useSessionStorage(
    'loadBoardLastQueryString',
    '',
  );

  useEffect(() => {
    if (currentPath === LOAD_BOARD_PAGE_PATH) {
      const queryString = searchParams?.toString() ?? '';

      setLastQueryString(queryString);
    }
  }, [currentPath, searchParams, setLastQueryString]);

  return (
    <LoadBoardLastQueryStringContext.Provider value={lastQueryString}>
      {children}
    </LoadBoardLastQueryStringContext.Provider>
  );
}
